module.exports = __webpack_public_path__ + "static/goshala-logo-3-40d50bdd9efb9abda8a3b9ac7209f201.jpg";